import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Pagination } from '~core/models/core.models';
import {
  CreateSalesPointParams,
  ListSalesPointRequestParams,
  SalesPoint,
  SalesPointImportParams,
  UpdateSalesPointParams
} from '~core/models/sales-point.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class SalesPointService {
  private _apiConstantsService = inject(ApiConstantsService);
  private _httpClient = inject(HttpClient);

  get apiUrl(): string {
    return this._apiConstantsService.salesPointsUrl;
  }

  read(salePointId: string): Observable<SalesPoint> {
    return this._httpClient.get<SalesPoint>(`${this.apiUrl}/${salePointId}`);
  }

  list(
    params?: ListSalesPointRequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<SalesPoint>> {
    return this._httpClient.get<Pagination<SalesPoint>>(this.apiUrl, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateSalesPointParams): Observable<SalesPoint> {
    return this._httpClient.post<SalesPoint>(this.apiUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    data: Partial<UpdateSalesPointParams>
  ): Observable<SalesPoint> {
    return this._httpClient.patch<SalesPoint>(`${this.apiUrl}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  remove(salePointId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(`${this.apiUrl}/${salePointId}`);
  }

  createFromBulk(params: SalesPointImportParams): Observable<void> {
    const formData = new FormData();
    formData.append('organizationId', params.organizationId);
    formData.append('file', params.file);

    return this._httpClient.post<void>(
      `${this.apiUrl}/create-from-bulk`,
      formData
    );
  }
}
